import { ElementType } from '../../../../common/elements/elementTypes';
import { CREATE_ELEMENT_TOOLBARS } from '../../../workspace/toolbar/config/toolbarMainToolListConfig';
import { ToolbarItemConfig, ToolbarListType } from '../../../workspace/toolbar/toolbarTypes';
import { getElementTypeToolsIntersection } from '../../../workspace/toolbar/utils/toolbarAvailableToolsUtils';

import * as elementRegistry from '../../../../common/elements/elementRegistry';
import { TOOLBAR_TOOLS } from '../../../workspace/toolbar/config/toolbarToolConfig';
import { MilanoteApplicationMode } from '../../../../common/platform/platformTypes';

const isMobileSupported = (tool: ToolbarItemConfig) =>
    tool.appModeAvailability.includes(MilanoteApplicationMode.mobile);

/**
 * Returns a base list of tools available for the given toolbar type + selected element types.
 */
export const getMobileBaseToolListItems = (
    elementTypes: Set<ElementType>,
    editorKey: string | undefined,
): Record<ToolbarListType, ToolbarItemConfig[]> => {
    return {
        [ToolbarListType.CREATE_ELEMENT]: CREATE_ELEMENT_TOOLBARS.MOBILE,
        [ToolbarListType.SELECTED]: getElementTypeToolsIntersection(
            elementTypes,
            editorKey,
            elementRegistry.getElementSelectedTools,
        ).filter(isMobileSupported),
        [ToolbarListType.EDITING]: getElementTypeToolsIntersection(
            elementTypes,
            editorKey,
            elementRegistry.getElementEditingTools,
        ).filter(isMobileSupported),
        [ToolbarListType.EDITING_RANGE]: getElementTypeToolsIntersection(
            elementTypes,
            editorKey,
            elementRegistry.getElementEditingRangeTools,
        ).filter(isMobileSupported),
        [ToolbarListType.MOBILE_TABS]: [],
        [ToolbarListType.MOBILE_GUEST]: [],
        /*
        the TOOLBAR_TOOLS.META_FAKE_TOOL tool in here not actually rendered,
        but used to ensure there's a distinct tool set between the TABS and UTILS toolbars
        this will ensure the toolbar is neatly transitioned when the toolbar type changes
        */
        [ToolbarListType.MOBILE_UTILS]: [TOOLBAR_TOOLS.META_FAKE_TOOL],
        [ToolbarListType.MOBILE_GUEST_UTILS]: [TOOLBAR_TOOLS.META_FAKE_TOOL],
    };
};
